import React from 'react'
import { Route, Switch } from 'react-router'
import { Auth } from 'components/Utility'
import { useSelector } from 'react-redux'
import { State } from './index'
import { getAuthShopRef, getIsAdmin, getRole, getStoreRef } from 'reducks/auth/selectors'
import { Role } from 'lib/role'
import {
  Login,
  Forget,
  ForgetConfirm,
  Top,
  AccountSettings,
  Account,
  ShoppingBag,
  Order,
  OrderByBread,
  Stock,
  UnreleasedStock,
  Schedule,
  ScheduleEdit,
  ScheduleEditComplete,
  ScheduleDeleteComplete,
  ScheduleCollectiveEditComplete,
  ScheduleCollectiveEditConfirm,
  ScheduleCollectiveEdit,
  ScheduledItem,
  Product,
  ProductDeleteComplete,
  ProductEdit,
  ProductEditConfirm,
  ProductEditComplete,
  ProductOrder,
  ProductOrderComplete,
  ShopEditAccount,
  ShopEditAccountComplete,
  ShopEditComplete,
  Shops,
  ShopEditInformation,
  ShopEditInformationComplete,
  ShopEditSettings,
  Balance,
  BankTransfer,
  MonthlyReport,
  MonthlyReportDetail,
  Revenue,
  RealtimeRevenue,
  Push,
  PushCreate,
  PushComplete,
  PushList,
  PushEdit,
  OrderSearch,
  Information,
  InformationConfirm,
  InformationComplete,
  Note,
  NoteComplete,
  Categories,
  CategoriesComplete,
  Tags,
  TagsEdit,
  Calendars,
  Contract,
  ContractCard,
  ContractComplete,
  Invoices,
  BusinessHour,
  SettingsConfirm,
  SettingsComplete,
  ShopEditInformationConfirm,
  SettingsTemporaryCloseComplete,
  SettingsTemporaryOpenConfirm,
  SettingsTemporaryCloseConfirm,
  SettingsTemporaryOpenComplete,
  DeepLink,
  PrintOrder,
  PrintOrderByBread,
  InviteMember,
  InviteMemberComplete,
  Register,
  RegisterComplete,
  RegisterError,
  RegisterUpdate,
  InviteOwner,
  Coupon,
  CouponCreate,
  CouponConfirm,
  CouponComplete,
  CouponLink,
  CouponList,
  CouponLinkComplete,
  CouponUsers,
  BankTransferComplete,
  Campaign,
  CampaignList,
  CampaignEdit,
  CampaignConfirm,
  CampaignComplete,
  StaffPush,
  StoreDeliveryFee,
  StoreDeliveryFeeComplete,
  StoreDeliveryFeeConfirm,
  DeliverySchedule,
  DeliveryScheduleEdit,
  DeliveryScheduleEditComplete,
  DeliveryScheduleCollectiveEdit,
  DeliveryScheduleCollectiveEditComplete,
  DeliveryScheduleCollectiveEditConfirm,
  DeliveryScheduleDeleteComplete,
  DeliveryOrder,
  PreparingDeliveryOrder,
  PrintDeliveryOrder,
  PrintPreparingDeliveryOrder,
  DepositHistory,
  DepositHistoryDetail,
  DepositHistoryDetailPrint,
  MonthlyReportDetailPrint,
  ExportDeliveryOrder,
  StoreDeliverySetting,
  StoreDeliverySettingYamato,
  TimeSale,
  TimeSaleProduct,
  ProductEditDefault,
  ReleasedStock,
  Customers,
  Customer,
  Message,
  MessageCreate,
  MessageList,
  MessageComplete,
  MessageEdit,
  Brands,
  BrandCreate,
  BrandEdit,
  BrandManager,
  PointCardCreate,
  PointCardEdit,
  PointCard,
  PointCardOfferCreate,
  PointCardOfferEdit,
  PointCardUser,
  PointCardEditComplete,
  PointCardCode,
  PointCardCodeInStore,
  PointCardCodeList,
  PointCardCodeDetail,
  PointCardCodeCreate,
  PointCardCodeEdit,
} from 'pages'

const Router = () => {
  const isAdmin = useSelector((state: State) => getIsAdmin(state))
  const shopRef = useSelector((state: State) => getAuthShopRef(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const role = useSelector((state: State) => getRole(state))
  const roleManager = new Role(role, storeRef)

  const isAdminViewingStore = isAdmin && (typeof storeRef !== 'undefined' || typeof shopRef !== 'undefined')

  if (isAdmin) {
    return (
      <Auth>
        <Switch>
          <Route exact path="/forget" component={Forget} />
          <Route exact path="/forget/confirm" component={ForgetConfirm} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/account" component={Account} />
          <Route exact path="/admin/campaign_cms" component={Campaign} />
          <Route exact path="/admin/campaign_cms/list" component={CampaignList} />
          <Route exact path="/admin/campaign_cms/create" component={CampaignEdit} />
          <Route exact path="/admin/campaign_cms/confirm" component={CampaignConfirm} />
          <Route exact path="/admin/campaign_cms/complete" component={CampaignComplete} />
          <Route exact path="/admin/campaign_cms/:id" component={CampaignEdit} />
          <Route exact path="/admin/coupon" component={Coupon} />
          <Route exact path="/admin/coupon/create" component={CouponCreate} />
          <Route exact path="/admin/coupon/create/confirm" component={CouponConfirm} />
          <Route exact path="/admin/coupon/create/complete" component={CouponComplete} />
          <Route exact path="/admin/coupon/list" component={CouponList} />
          <Route exact path="/admin/coupon/list/complete" component={CouponLinkComplete} />
          <Route exact path="/admin/coupon/list/:id" component={CouponLink} />
          <Route exact path="/admin/coupon/:id/user" component={CouponUsers} />
          <Route exact path="/admin/shops" component={Shops} />
          <Route exact path="/admin/shops/create/account" component={ShopEditAccount} />
          <Route exact path="/admin/shops/create/complete" component={ShopEditComplete} />
          <Route exact path="/admin/shops/create/information" component={ShopEditInformation} />
          <Route exact path="/admin/shops/:id/account" component={ShopEditAccount} />
          <Route exact path="/admin/shops/:id/information" component={ShopEditInformation} />
          <Route exact path="/admin/shops/:id/account/complete" component={ShopEditAccountComplete} />
          <Route exact path="/admin/shops/:id/information/complete" component={ShopEditInformationComplete} />
          <Route exact path="/admin/shops/:id/information/confirm" component={ShopEditInformationConfirm} />
          <Route exact path="/admin/shops/:id/invite_owner" component={InviteOwner} />
          <Route exact path="/admin/shops/:id/settings" component={ShopEditSettings} />
          <Route exact path="/admin/push_notification" component={Push} />
          <Route exact path="/admin/push_notification/create" component={PushCreate} />
          <Route exact path="/admin/push_notification/complete" component={PushComplete} />
          <Route exact path="/admin/push_notification/list" component={PushList} />
          <Route exact path="/admin/push_notification/:id" component={PushEdit} />
          <Route exact path="/admin/orders/search" component={OrderSearch} />
          <Route exact path="/admin/master/categories" component={Categories} />
          <Route exact path="/admin/master/categories/complete" component={CategoriesComplete} />
          <Route exact path="/admin/master/tags" component={Tags} />
          <Route exact path="/admin/master/tags/create" component={TagsEdit} />
          <Route exact path="/admin/master/tags/:id" component={TagsEdit} />
          <Route exact path="/admin/master/calendars" component={Calendars} />
          <Route exact path="/admin/brand" component={Brands} />
          <Route exact path="/admin/brand/create" component={BrandCreate} />
          <Route exact path="/admin/brand/:id" component={BrandEdit} />
          <Route exact path="/admin/brand/create/manager" component={BrandManager} />
          <Route exact path="/admin/brand/:id/manager" component={BrandManager} />
          {isAdminViewingStore && (
            <Switch>
              <Route exact path="/" component={Top} />
              <Route exact path="/account" component={Account} />
              <Route exact path="/account/invite_member" component={InviteMember} />
              <Route exact path="/account/invite_member/complete" component={InviteMemberComplete} />
              <Route exact path="/account/revenue" component={Revenue} />
              <Route exact path="/account/revenue/balance" component={Balance} />
              <Route exact path="/account/revenue/bank_transfer" component={BankTransfer} />
              <Route exact path="/account/revenue/bank_transfer/complete" component={BankTransferComplete} />
              <Route exact path="/account/revenue/deposit_history" component={DepositHistory} />
              <Route exact path="/account/revenue/deposit_history/print/:id" component={DepositHistoryDetailPrint} />
              <Route exact path="/account/revenue/deposit_history/:id" component={DepositHistoryDetail} />
              <Route exact path="/account/revenue/monthly_report" component={MonthlyReport} />
              <Route exact path="/account/revenue/monthly_report/:month" component={MonthlyReportDetail} />
              <Route exact path="/account/revenue/monthly_report/print/:month" component={MonthlyReportDetailPrint} />
              <Route exact path="/account/revenue/realtime" component={RealtimeRevenue} />
              <Route exact path="/account/note" component={Note} />
              <Route exact path="/account/note/complete" component={NoteComplete} />
              <Route exact path="/account/settings" component={AccountSettings} />
              <Route exact path="/account/settings/business_hour" component={BusinessHour} />
              <Route exact path="/account/settings/confirm" component={SettingsConfirm} />
              <Route exact path="/account/settings/complete" component={SettingsComplete} />
              <Route exact path="/account/settings/close/complete" component={SettingsTemporaryCloseComplete} />
              <Route exact path="/account/settings/close/confirm" component={SettingsTemporaryCloseConfirm} />
              <Route exact path="/account/settings/deep_link" component={DeepLink} />
              <Route exact path="/account/settings/open/complete" component={SettingsTemporaryOpenComplete} />
              <Route exact path="/account/settings/open/confirm" component={SettingsTemporaryOpenConfirm} />
              <Route exact path="/account/shopping-bag/edit" component={ShoppingBag} />
              <Route exact path="/account/information/edit" component={Information} />
              <Route exact path="/account/information/confirm" component={InformationConfirm} />
              <Route exact path="/account/information/complete" component={InformationComplete} />
              <Route exact path="/contract" component={Contract} />
              <Route exact path="/contract/card" component={ContractCard} />
              <Route exact path="/contract/card/complete" component={ContractComplete} />
              <Route exact path="/contract/invoices" component={Invoices} />
              <Route exact path="/delivery/setting" component={StoreDeliverySetting} />
              <Route exact path="/delivery/setting/fee" component={StoreDeliveryFee} />
              <Route exact path="/delivery/setting/fee/complete" component={StoreDeliveryFeeComplete} />
              <Route exact path="/delivery/setting/fee/confirm" component={StoreDeliveryFeeConfirm} />
              <Route exact path="/delivery/setting/yamato" component={StoreDeliverySettingYamato} />
              <Route exact path="/order/print/:date" component={PrintOrder} />
              <Route exact path="/order/print/:date/product" component={PrintOrderByBread} />
              <Route exact path="/order/delivery/export/:date" component={ExportDeliveryOrder} />
              <Route exact path="/order/delivery/print/preparing" component={PrintPreparingDeliveryOrder} />
              <Route exact path="/order/delivery/print/:date" component={PrintDeliveryOrder} />
              <Route exact path="/order/delivery/preparing" component={PreparingDeliveryOrder} />
              <Route exact path="/order/delivery/:date" component={DeliveryOrder} />
              <Route exact path="/order/:date" component={Order} />
              <Route exact path="/order/:date/product" component={OrderByBread} />
              <Route exact path="/stock" component={Stock} />
              <Route exact path="/stock/released" component={ReleasedStock} />
              <Route exact path="/stock/unreleased" component={UnreleasedStock} />
              <Route exact path="/schedule" component={Schedule} />
              <Route exact path="/schedule/collective_setting" component={ScheduleCollectiveEdit} />
              <Route exact path="/schedule/collective_setting/confirm" component={ScheduleCollectiveEditConfirm} />
              <Route exact path="/schedule/collective_setting/complete" component={ScheduleCollectiveEditComplete} />
              <Route exact path="/schedule/delivery" component={DeliverySchedule} />
              <Route exact path="/schedule/delivery/collective_setting" component={DeliveryScheduleCollectiveEdit} />
              <Route
                exact
                path="/schedule/delivery/collective_setting/complete"
                component={DeliveryScheduleCollectiveEditComplete}
              />
              <Route
                exact
                path="/schedule/delivery/collective_setting/confirm"
                component={DeliveryScheduleCollectiveEditConfirm}
              />
              <Route exact path="/schedule/delivery/:id" component={DeliveryScheduleEdit} />
              <Route exact path="/schedule/delivery/:id/delete" component={DeliveryScheduleDeleteComplete} />
              <Route exact path="/schedule/delivery/:id/complete" component={DeliveryScheduleEditComplete} />
              <Route exact path="/schedule/:id" component={ScheduleEdit} />
              <Route exact path="/schedule/:id/complete" component={ScheduleEditComplete} />
              <Route exact path="/schedule/:id/delete" component={ScheduleDeleteComplete} />
              <Route exact path="/scheduled_item/:date" component={ScheduledItem} />
              <Route exact path="/product" component={Product} />
              <Route exact path="/product/create" component={ProductEdit} />
              <Route exact path="/product/complete" component={ProductEditComplete} />
              <Route exact path="/product/confirm" component={ProductEditConfirm} />
              <Route exact path="/product/default" component={ProductEditDefault} />
              <Route exact path="/product/delete" component={ProductDeleteComplete} />
              <Route exact path="/product/edit/:id" component={ProductEdit} />
              <Route exact path="/product/edit/complete/:id" component={ProductEditComplete} />
              <Route exact path="/product/edit/confirm/:id" component={ProductEditConfirm} />
              <Route exact path="/product/order" component={ProductOrder} />
              <Route exact path="/product/order/complete" component={ProductOrderComplete} />
              <Route exact path="/staffpush" component={StaffPush} />
              <Route exact path="/time_sale" component={TimeSale} />
              <Route exact path="/time_sale/product" component={TimeSaleProduct} />
              <Route exact path="/customer" component={Customers} />
              <Route exact path="/customer/message" component={Message} />
              <Route exact path="/customer/message/create" component={MessageCreate} />
              <Route exact path="/customer/message/list" component={MessageList} />
              <Route exact path="/customer/message/complete" component={MessageComplete} />
              <Route exact path="/customer/message/:id" component={MessageEdit} />
              <Route exact path="/customer/:uid" component={Customer} />
              <Route exact path="/point_card" component={PointCard} />
              <Route exact path="/point_card/user" component={PointCardUser} />
              <Route exact path="/point_card/create" component={PointCardCreate} />
              <Route exact path="/point_card/complete" component={PointCardEditComplete} />
              <Route exact path="/point_card/code" component={PointCardCode} />
              <Route exact path="/point_card/:id" component={PointCardEdit} />
              <Route exact path="/point_card/offer/create" component={PointCardOfferCreate} />
              <Route exact path="/point_card/offer/:id" component={PointCardOfferEdit} />
              <Route exact path="/point_card/code/in_store" component={PointCardCodeInStore} />
              <Route exact path="/point_card/code/list" component={PointCardCodeList} />
              <Route exact path="/point_card/code/create" component={PointCardCodeCreate} />
              <Route exact path="/point_card/code/:id" component={PointCardCodeDetail} />
              <Route exact path="/point_card/code/:id/edit" component={PointCardCodeEdit} />
            </Switch>
          )}
        </Switch>
      </Auth>
    )
  } else {
    return (
      <Auth>
        <Switch>
          <Route exact path="/forget" component={Forget} />
          <Route exact path="/forget/confirm" component={ForgetConfirm} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/register" component={Register} />
          <Route exact path="/register/complete" component={RegisterComplete} />
          <Route exact path="/register/error" component={RegisterError} />
          <Route exact path="/register/update" component={RegisterUpdate} />
          {roleManager.hasEnoughRole(1) && (
            <Switch>
              <Route exact path="/" component={Top} />
              <Route exact path="/account" component={Account} />
              <Route exact path="/order/print/:date" component={PrintOrder} />
              <Route exact path="/order/print/:date/product" component={PrintOrderByBread} />
              <Route exact path="/order/delivery/export/:date" component={ExportDeliveryOrder} />
              <Route exact path="/order/delivery/print/preparing" component={PrintPreparingDeliveryOrder} />
              <Route exact path="/order/delivery/print/:date" component={PrintDeliveryOrder} />
              <Route exact path="/order/delivery/preparing" component={PreparingDeliveryOrder} />
              <Route exact path="/order/delivery/:date" component={DeliveryOrder} />
              <Route exact path="/order/:date" component={Order} />
              <Route exact path="/order/:date/product" component={OrderByBread} />
              <Route exact path="/scheduled_item/:date" component={ScheduledItem} />
              {roleManager.hasEnoughRole(5, isAdminViewingStore) && (
                <Switch>
                  {roleManager.hasEnoughRole(9, isAdminViewingStore) && (
                    <Switch>
                      <Route exact path="/account/invite_member" component={InviteMember} />
                      <Route exact path="/account/invite_member/complete" component={InviteMemberComplete} />
                      <Route exact path="/account/note" component={Note} />
                      <Route exact path="/account/note/complete" component={NoteComplete} />
                      <Route exact path="/account/revenue" component={Revenue} />
                      <Route exact path="/account/revenue/balance" component={Balance} />
                      <Route exact path="/account/revenue/bank_transfer" component={BankTransfer} />
                      <Route exact path="/account/revenue/bank_transfer/complete" component={BankTransferComplete} />
                      <Route exact path="/account/revenue/deposit_history" component={DepositHistory} />
                      <Route
                        exact
                        path="/account/revenue/deposit_history/print/:id"
                        component={DepositHistoryDetailPrint}
                      />
                      <Route exact path="/account/revenue/deposit_history/:id" component={DepositHistoryDetail} />
                      <Route exact path="/account/revenue/monthly_report" component={MonthlyReport} />
                      <Route exact path="/account/revenue/monthly_report/:month" component={MonthlyReportDetail} />
                      <Route
                        exact
                        path="/account/revenue/monthly_report/print/:month"
                        component={MonthlyReportDetailPrint}
                      />
                      <Route exact path="/account/revenue/realtime" component={RealtimeRevenue} />
                      <Route exact path="/account/settings/business_hour" component={BusinessHour} />
                      <Route exact path="/account/settings" component={AccountSettings} />
                      <Route exact path="/account/settings/confirm" component={SettingsConfirm} />
                      <Route exact path="/account/settings/complete" component={SettingsComplete} />
                      <Route exact path="/account/settings/close/complete" component={SettingsTemporaryCloseComplete} />
                      <Route exact path="/account/settings/close/confirm" component={SettingsTemporaryCloseConfirm} />
                      <Route exact path="/account/settings/deep_link" component={DeepLink} />
                      <Route exact path="/account/settings/open/complete" component={SettingsTemporaryOpenComplete} />
                      <Route exact path="/account/settings/open/confirm" component={SettingsTemporaryOpenConfirm} />
                      <Route exact path="/account/shopping-bag/edit" component={ShoppingBag} />
                      <Route exact path="/account/information/edit" component={Information} />
                      <Route exact path="/account/information/confirm" component={InformationConfirm} />
                      <Route exact path="/account/information/complete" component={InformationComplete} />
                      <Route exact path="/contract" component={Contract} />
                      <Route exact path="/contract/card" component={ContractCard} />
                      <Route exact path="/contract/card/complete" component={ContractComplete} />
                      <Route exact path="/contract/invoices" component={Invoices} />
                      <Route exact path="/delivery/setting" component={StoreDeliverySetting} />
                      <Route exact path="/delivery/setting/fee" component={StoreDeliveryFee} />
                      <Route exact path="/delivery/setting/fee/complete" component={StoreDeliveryFeeComplete} />
                      <Route exact path="/delivery/setting/fee/confirm" component={StoreDeliveryFeeConfirm} />
                      <Route exact path="/delivery/setting/yamato" component={StoreDeliverySettingYamato} />
                      <Route exact path="/stock" component={Stock} />
                      <Route exact path="/stock/released" component={ReleasedStock} />
                      <Route exact path="/stock/unreleased" component={UnreleasedStock} />
                      <Route exact path="/schedule" component={Schedule} />
                      <Route exact path="/schedule/collective_setting" component={ScheduleCollectiveEdit} />
                      <Route
                        exact
                        path="/schedule/collective_setting/confirm"
                        component={ScheduleCollectiveEditConfirm}
                      />
                      <Route
                        exact
                        path="/schedule/collective_setting/complete"
                        component={ScheduleCollectiveEditComplete}
                      />
                      <Route exact path="/schedule/delivery" component={DeliverySchedule} />
                      <Route
                        exact
                        path="/schedule/delivery/collective_setting"
                        component={DeliveryScheduleCollectiveEdit}
                      />
                      <Route
                        exact
                        path="/schedule/delivery/collective_setting/complete"
                        component={DeliveryScheduleCollectiveEditComplete}
                      />
                      <Route
                        exact
                        path="/schedule/delivery/collective_setting/confirm"
                        component={DeliveryScheduleCollectiveEditConfirm}
                      />
                      <Route exact path="/schedule/delivery/:id" component={DeliveryScheduleEdit} />
                      <Route exact path="/schedule/delivery/:id/delete" component={DeliveryScheduleDeleteComplete} />
                      <Route exact path="/schedule/delivery/:id/complete" component={DeliveryScheduleEditComplete} />
                      <Route exact path="/schedule/:id" component={ScheduleEdit} />
                      <Route exact path="/schedule/:id/complete" component={ScheduleEditComplete} />
                      <Route exact path="/schedule/:id/delete" component={ScheduleDeleteComplete} />
                      <Route exact path="/scheduled_item/:date" component={ScheduledItem} />
                      <Route exact path="/product" component={Product} />
                      <Route exact path="/product/create" component={ProductEdit} />
                      <Route exact path="/product/complete" component={ProductEditComplete} />
                      <Route exact path="/product/confirm" component={ProductEditConfirm} />
                      <Route exact path="/product/default" component={ProductEditDefault} />
                      <Route exact path="/product/delete" component={ProductDeleteComplete} />
                      <Route exact path="/product/edit/:id" component={ProductEdit} />
                      <Route exact path="/product/edit/complete/:id" component={ProductEditComplete} />
                      <Route exact path="/product/edit/confirm/:id" component={ProductEditConfirm} />
                      <Route exact path="/product/order" component={ProductOrder} />
                      <Route exact path="/product/order/complete" component={ProductOrderComplete} />
                      <Route exact path="/staffpush" component={StaffPush} />
                      <Route exact path="/time_sale" component={TimeSale} />
                      <Route exact path="/time_sale/product" component={TimeSaleProduct} />
                      <Route exact path="/customer" component={Customers} />
                      <Route exact path="/customer/message" component={Message} />
                      <Route exact path="/customer/message/create" component={MessageCreate} />
                      <Route exact path="/customer/message/list" component={MessageList} />
                      <Route exact path="/customer/message/complete" component={MessageComplete} />
                      <Route exact path="/customer/message/:id" component={MessageEdit} />
                      <Route exact path="/customer/:uid" component={Customer} />
                      <Route exact path="/point_card" component={PointCard} />
                      <Route exact path="/point_card/user" component={PointCardUser} />
                      <Route exact path="/point_card/create" component={PointCardCreate} />
                      <Route exact path="/point_card/complete" component={PointCardEditComplete} />
                      <Route exact path="/point_card/code" component={PointCardCode} />
                      <Route exact path="/point_card/:id" component={PointCardEdit} />
                      <Route exact path="/point_card/offer/create" component={PointCardOfferCreate} />
                      <Route exact path="/point_card/offer/:id" component={PointCardOfferEdit} />
                      <Route exact path="/point_card/code/in_store" component={PointCardCodeInStore} />
                      <Route exact path="/point_card/code/list" component={PointCardCodeList} />
                      <Route exact path="/point_card/code/create" component={PointCardCodeCreate} />
                      <Route exact path="/point_card/code/:id" component={PointCardCodeDetail} />
                      <Route exact path="/point_card/code/:id/edit" component={PointCardCodeEdit} />
                    </Switch>
                  )}
                </Switch>
              )}
            </Switch>
          )}
        </Switch>
      </Auth>
    )
  }
}
export default Router
